import type { Reference } from '@sydle/ui-api';
import type { CommandBody } from '../CrossOriginMessage';

/**
 * Used to refresh a specific view, regardless of which slot it is in.
 */
export class RefreshCommandBody implements CommandBody {
  /**
   * Reference to changed object.
   */
  ref?: Reference;

  /**
   * Reference to changed object.
   */
  viewType?: string;
}
